module.exports = __webpack_public_path__ + "img/bottom.d0fa7e4c.png";